import { AlbedoColor, OutlineColor } from './SceneApi';
import { ComponentIds, SelectableComponent } from '@inter-ikea-core/core';
export class BaseSceneApi {
    constructor(core, ipexViewer, reportErrorToSentry) {
        this.baseMaterialId = -1;
        this.core = core;
        this.ipexViewer = ipexViewer;
        this.reportErrorToSentry = reportErrorToSentry;
        this.selectionSystemDisabled = false;
        this.measurementsLineCenters = [];
        this.showMeasurements = true;
        this.wallVisibility = {};
        this.measurementLines = [];
        this.onlyShowMeasurementIds = [];
        this.selectableEntities = [];
    }
    enableSelectionSystem() {
        this.selectableEntities.forEach(entity => !entity.isDisposed && entity.addComponent(new SelectableComponent()));
        this.selectionSystemDisabled = false;
    }
    disableSelectionSystem() {
        this.selectableEntities = this.core.services.sceneManager.entities.filter(entity => entity.hasComponent(ComponentIds.SELECTABLE_COMPONENT_ID));
        this.selectableEntities.forEach(entity => entity.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID));
        this.selectionSystemDisabled = true;
    }
    setGlobalOutlineColor(color) {
        switch (color) {
            case OutlineColor.YELLOW:
                this.ipexViewer.set_global_outline_color({ r: 1, g: 1, b: 0 });
                break;
            case OutlineColor.RED:
                this.ipexViewer.set_global_outline_color({ r: 224 / 255, g: 7 / 255, b: 81 / 255 });
                break;
            case OutlineColor.ORANGE:
                this.ipexViewer.set_global_outline_color({ r: 242 / 255, g: 106 / 255, b: 47 / 255 });
                break;
            case OutlineColor.BLUE:
                this.ipexViewer.set_global_outline_color({ r: 0 / 255, g: 88 / 255, b: 163 / 255 });
                break;
            case OutlineColor.BLACK:
                this.ipexViewer.set_global_outline_color({ r: 0, g: 0, b: 0 });
                break;
        }
    }
    setObjectBaseColor(color, frameObjectId) {
        if (this.baseMaterialId === -1) {
            this.baseMaterialId = this.ipexViewer.create_material();
            this.ipexViewer.set_base_color(this.baseMaterialId, {
                r: 1.0,
                g: 1.0,
                b: 1.0
            });
        }
        if (color === AlbedoColor.RED) {
            // To be able to color objects it seems they need to have a material. So we applay a white base material before coloring it red.
            this.ipexViewer.set_material(frameObjectId, this.baseMaterialId);
            this.ipexViewer.set_object_base_color_factor(frameObjectId, {
                r: 1,
                g: 73 / 255,
                b: 134 / 255
            });
        }
        else if (color === AlbedoColor.NONE) {
            this.ipexViewer.set_object_base_color_factor(frameObjectId, { r: 1, g: 1, b: 1 });
            this.ipexViewer.set_material(frameObjectId, null);
        }
    }
    setSceneHasConflicts(hasConflicts) {
        if (hasConflicts) {
            this.setGlobalOutlineColor(OutlineColor.ORANGE);
            this.disableSelectionSystem();
        }
        else {
            this.setGlobalOutlineColor(OutlineColor.BLUE);
            this.enableSelectionSystem();
        }
    }
    setSceneHasUnavailableProducts(hasUnavailableProducts) {
        if (hasUnavailableProducts) {
            this.setGlobalOutlineColor(OutlineColor.ORANGE);
        }
        else {
            this.setGlobalOutlineColor(OutlineColor.BLUE);
        }
    }
    setWallVisibility(walls) {
        this.wallVisibility = walls;
    }
    getWallVisibility() {
        return this.wallVisibility;
    }
    setMeasurementsLineCenters(centers) {
        this.measurementsLineCenters = centers.flatMap((center) => {
            const { position, dim, wall } = center;
            const point = this.core.services.coreModules
                .viewer()
                ?.worldCoordToCanvas(position.x, position.y, position.z);
            if (point) {
                return {
                    dim,
                    wall,
                    x: point.X,
                    y: point.Y
                };
            }
            return [];
        });
    }
    getMeasurementsLineCenters() {
        return this.measurementsLineCenters;
    }
    setMeasurementLines(lines) {
        //TODO: This line is needed but also throws warnings in console about not being able to remove
        //lines with id -1
        this.measurementLines.forEach(l => l.dispose());
        this.measurementLines = [];
        if (lines) {
            lines.forEach(line => {
                this.measurementLines.push(line);
            });
        }
    }
    showMeasurementLines() {
        this.measurementLines?.forEach(line => (line.visible = true));
    }
    hideMeasurementLines() {
        this.measurementLines?.forEach(line => (line.visible = false));
    }
    hideMeasurementsLine(line) {
        line.visible = false;
    }
    setOnlyShowMeasurements(measurementIds) {
        this.onlyShowMeasurementIds = measurementIds;
    }
}
export var MeasurementsEnum;
(function (MeasurementsEnum) {
    MeasurementsEnum["FrameMeasurements"] = "FrameMeasurements";
    MeasurementsEnum["FrameInnerMeasurements"] = "FrameInnerMeasurements";
    MeasurementsEnum["HelpLinesShapeMeasurements"] = "HelpLinesShapeMeasurements";
    MeasurementsEnum["HelpLinesFrameOuterMeasurements"] = "HelpLinesFrameOuterMeasurements";
})(MeasurementsEnum || (MeasurementsEnum = {}));
//# sourceMappingURL=BaseSceneApi.js.map